import { Component, OnInit } from '@angular/core';
import { ParamLandpageService } from 'src/app/shared/services/utilities/param-landpage.service';
import { ParamLandpageModel } from 'src/app/shared/models/simple-types/param-landpage.model';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-gestion-actualite',
  templateUrl: './gestion-actualite.component.html',
  styleUrls: ['./gestion-actualite.component.scss']
})
export class GestionActualiteComponent implements OnInit {

  paramLandpage: ParamLandpageModel[];
  newParamLandpage: ParamLandpageModel[];
  actuForm = new UntypedFormGroup({
    actu: new UntypedFormControl(['']),
    buttons: new UntypedFormArray([])
  });
  maxTitle = 45;
  maxURL = 255;
  lenghtError = "Veuillez respecter les limites de caractères";
  valTitle = Validators.maxLength(this.maxTitle);
  valURL = Validators.maxLength(this.maxURL);

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    private paramLandpageService: ParamLandpageService, 
    private fb: UntypedFormBuilder,
    private toastrService: ToastrService) {
    this.paramLandpageService.getAll().subscribe(result => {
      this.paramLandpage = result;
      if (this.paramLandpage && this.paramLandpage.length == 0) {
        this.paramLandpage.push(new ParamLandpageModel());
        this.paramLandpage[0].id = 1;
        this.paramLandpageService.save(this.paramLandpage[0]).subscribe();
      } else if (this.paramLandpage && this.paramLandpage.length > 0) {
        if (this.paramLandpage[0].info == null) {
          this.actuForm.get('actu').setValue("");
        } else {
          this.actuForm.get('actu').setValue(this.paramLandpage[0].info);
        }
      }
      let i = 1;
      while (i < this.paramLandpage.length) {
        this.buttonsFormArray.push(
          this.fb.group({
            btnTitle: [this.paramLandpage[i].titreBouton, [this.valTitle]],
            btnURL: [this.paramLandpage[i].urlBouton, [this.valURL]],
            btId: [this.paramLandpage[i].id, []],
          })
        );
        i++;
      }
    });
   }

  ngOnInit(): void {}

  onLeave() {
    let change = false;
    let i = 0;
    while (i < this.paramLandpage.length && change == false) {
      if (i == 0 && this.paramLandpage[i].info != this.actuForm.get('actu').value) {
        change = true;
      } else if (i > 0 && 
          (this.paramLandpage[i].titreBouton != this.buttonsFormArray.controls[i - 1].get('btnTitle').value || 
          this.paramLandpage[i].urlBouton != this.buttonsFormArray.controls[i - 1].get('btnURL').value)) {
            change = true;
      }
      i++;
    }
    if (!change) {
      this.router.navigate(['/gestion-referentiel']);
    } else {
      const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
        data: {
          title: 'Vous avez des modifications non sauvegardées, êtes vous sur de vouloir quitter ?',
          message: '',
          color: 'warn'
        }
      });
      return dialogConfirmation.afterClosed().subscribe((res) => {
        if (res) {
          this.router.navigate(['/gestion-referentiel']);
        }
      });    
    }    
  }

  validate() {
    if (this.actuForm.status === 'VALID') {
      this.newParamLandpage = [];
      let i = 0;
      while (i < this.paramLandpage.length) {
        if (i == 0 && this.paramLandpage[i].info != this.actuForm.get('actu').value) {
          this.newParamLandpage.push(Object.assign({}, this.paramLandpage[i]));
          this.newParamLandpage[this.newParamLandpage.length - 1].info = this.actuForm.get('actu').value;
        } else if (i > 0 && 
            (this.paramLandpage[i].titreBouton != this.buttonsFormArray.controls[i - 1].get('btnTitle').value || 
            this.paramLandpage[i].urlBouton != this.buttonsFormArray.controls[i - 1].get('btnURL').value)) {
          this.newParamLandpage.push(Object.assign({}, this.paramLandpage[i]));
          this.newParamLandpage[this.newParamLandpage.length - 1].titreBouton = this.buttonsFormArray.controls[i - 1].get('btnTitle').value;
          this.newParamLandpage[this.newParamLandpage.length - 1].urlBouton = this.buttonsFormArray.controls[i - 1].get('btnURL').value;
        }
        i++;
      }
      if (this.newParamLandpage.length == 0) {
        this.toastrService.warning('Aucune modification à enregistrer.');
      } else {
        this.paramLandpageService.updateAll(this.newParamLandpage).subscribe((ret) => {
          if (ret) {
            this.toastrService.success('Enregistrement des informations réussi.');
            for (let newParam of this.newParamLandpage) {
              let paramId = this.paramLandpage.findIndex(param => 
                param.id == newParam.id
              );
              if (paramId != -1) {
                this.paramLandpage[paramId] = Object.assign({}, newParam);
              }
            }
          } else {
            this.toastrService.error('Erreur durant l’enregistrement des informations.', 'Erreur');
          }
        });
      }
    } else {
      this.toastrService.warning(this.lenghtError);
    }
  }

  get buttonsFormArray() : UntypedFormArray {
    return this.actuForm.get("buttons") as UntypedFormArray
  }

  get buttonsFonmControl(): UntypedFormControl[] {
    return (this.actuForm.get("buttons") as UntypedFormArray).controls as UntypedFormControl[];
  }

  addButton() {
    this.paramLandpage.push(new ParamLandpageModel());
    this.paramLandpage[this.paramLandpage.length - 1].id = this.paramLandpage[this.paramLandpage.length - 2].id + 1;
    this.paramLandpageService.save(this.paramLandpage[this.paramLandpage.length - 1]).subscribe((ret) => {
      if (ret) {
        this.toastrService.success('Bouton crée.');
        this.buttonsFormArray.push(
          this.fb.group({
            btnTitle: ["", [this.valTitle]],
            btnURL: ["", [this.valURL]],
            btId: [this.paramLandpage[this.paramLandpage.length - 1].id, []],
          }));
      } else {
        this.toastrService.error('Erreur durant la création du bouton.', 'Erreur');
      }
    });
  }

  delButton(i: number) {
    let id: Number;
    const dialogConfirmation = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Voulez-vous Supprimer le bouton ' + (i + 1) + (this.paramLandpage[i + 1].titreBouton ? (' : ' + this.paramLandpage[i + 1].titreBouton) : "") + ' ?',
        message: '',
        color: 'warn'
      }
    });
    return dialogConfirmation.afterClosed().subscribe((res) => {
      if (res) {
        this.paramLandpageService.delete(this.paramLandpage[i + 1].id).subscribe((ret) => {
          if (ret) {
            this.toastrService.success('Bouton ' + (i + 1) + ' supprimé.');
            this.paramLandpage.splice(i + 1, 1);
            this.buttonsFormArray.removeAt(i);
          } else {
            this.toastrService.error('Erreur durant la supression du bouton.', 'Erreur');
          }
        });
      }
    });    
  }
}